import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { BsButton, BsForm, BsFormControl } from '../../collection/bootstrap/BootstrapComponents';
import { apiForm, apiGet } from '../../utils/api';
import { removeStorageItem, setStorageValue } from '../../utils/functions';
import { swalert } from '../../utils/notifications';

export default function PasswordRecovery(props) {
    const token = props.token;
    const [nav, setNav] = useState(false);

    const updateData = async () => await apiGet("usuarios/getbytoken/" + token);

    const saveData = async data => {
        setStorageValue("token", token);
        const result = await apiForm("usuarios/recovery", data);
        removeStorageItem("token");
        if (result) {
            swalert("Guardado", "Contraseña actualizada", "success");
            setNav(true);
        }
    }

    const checkData = formData => {
        let errors = {};
        // Contraseña
        const password = formData.get("password");
        if (!password) {
            errors["password"] = "Campo obligatorio";
        }
        // Confirmar contraseña
        const confirmPassword = formData.get("confirmPassword");
        if ((password || confirmPassword) && password !== confirmPassword) {
            errors["confirmPassword"] = "Las contraseñas no coinciden";
        }
        return errors;
    }

    return nav ? <Navigate to="/" /> : <>
        <h2>Crear nueva contraseña</h2>
        <BsForm
            onUpdate={updateData}
            onSave={saveData}
            onCheck={checkData}>
            <PasswordForm />
        </BsForm>
    </>;
}

function PasswordForm(props) {
    const data = props.data;
    const errors = props.errors;
    return <>
        <Row className="mt-2 gy-3">
            { /* Username */}
            <Col md="6">
                <BsFormControl
                    label="Usuario"
                    value={data.username}
                    readOnly />
            </Col>
            { /* Nombre */}
            <Col md="6">
                <BsFormControl
                    label="Nombre"
                    value={data.name + ' ' + data.apellidos}
                    readOnly />
            </Col>
            { /* Contraseña */}
            <Col md="6">
                <BsFormControl
                    label="Contraseña" name="password"
                    error={errors.password}
                    type="password" isNewPassword />
            </Col>
            <Col md="6">
                <BsFormControl
                    label="Confirmar contraseña" name="confirmPassword"
                    error={errors.confirmPassword}
                    type="password" isNewPassword />
            </Col>
        </Row>
        <div className="d-flex justify-content-center gap-3 mt-3">
            <BsButton onClick={props.onSubmit} isLoading={props.isSaving}>Guardar</BsButton>
        </div>
    </>;
}
